import { AuthPage } from "@refinedev/antd";

export const ForgotPassword = () => {
  return <AuthPage type="forgotPassword" title="Smart Tech App" />;
};
